import { Icon } from '@advanza/ui'
import clsx from 'clsx'
import { getChatbotLeadLabel, isChatbotLead } from 'misc/chatbotLead'

interface Props {
    request: {
        request_type?: string | null
        source?: string | null
    }
    className?: string
}

/**
 * Marks a lead that came from the provider's own embedded conversion chatbot.
 *
 * Such a lead never went through the marketplace: it matches a single provider, is confirmed
 * on creation, is always free of charge and carries no subject option. The badge exists so
 * that request does not read as a broken marketplace lead.
 */
const RequestChatbotBadge = ({ request, className }: Props) => {
    if (!isChatbotLead(request.request_type)) {
        return null
    }

    return (
        <span
            title="Lead from the provider's own embedded chatbot: single provider, free of charge"
            className={clsx(
                'inline-flex items-center gap-1 rounded px-2 py-0.5 text-sm font-bold',
                // Pinned to the pro dashboard's chatbot label so both surfaces read the same.
                'bg-[#eaf2ff] text-[#317bff]',
                className,
            )}>
            <Icon name="smart_toy" fontSize={14} />
            {getChatbotLeadLabel(request.source)}
        </span>
    )
}

export default RequestChatbotBadge
